enum ReportRoutes {
  ReportList = '/content-settings/reports',
  ReportAdd = '/content-settings/reports/add',
  ReportEdit = '/content-settings/reports/:id',
}

export default ReportRoutes
